import { Column, div, Flex } from "lqx-react/lib";
import * as React from "react";
import { DirectoryPath } from "../../api/connectionSettings";
import { PlatformsLookup, ProductsLookup } from "../../api/lookups";
import { DestinationTargetCard } from "./destination-target-card";

export const DestinationTargets = (
    { path, products, platforms }:
        { path: DirectoryPath, products: ProductsLookup, platforms: PlatformsLookup }) => {

    return path ? (<div style={{ marginLeft: '16px' }}>
        <Flex row>
            <Column>
                <FilePathContainer>
                    {path.emailFrom ? '' : 'File Path:'} {path.emailFrom || path.path}
                </FilePathContainer>
            </Column>
        </Flex>
        {path.destinationTargets.map((destionationTargetCard, i) =>
            <DestinationTargetCard
                key={i}
                destinationTargetCard={destionationTargetCard}
                products={products}
                platforms={platforms}
                fileCode={path.$.fileCode.value}
            ></DestinationTargetCard>
        )}
    </div>) : <></>;
}

const FilePathContainer = div({
    color: '#052C4C',
    display: 'flex',
    fontSize: '14px',
    alignItems: 'center',
    fontWeight: 600,
    marginRight: '1em',
    marginTop: '10px',
    marginBottom: '20px',
    textTransform: 'uppercase'
})